import { Layout, Map } from '@/views/map'

export default {
  path: 'map',
  //name: 'customers_list',
  component: Layout,
  children: [
    //{ path: '', component: Map },
    { path: '', name: 'map', component: Map }
    /* {
            path: ':id',
            name: 'customer_details',
            component: Details,
            props: (route) => {
                return { ...route.params, ...{ customerId: Number.parseInt(route.params.id, 10) || undefined } }
            }
        }*/
    // { path: 'add', component: AddEdit },
    // { path: 'edit/:id', component: AddEdit }
  ]
}
